//@flow
import React from 'react';

import type { ImageSizeType } from '../types/ImageSizeType';

// $FlowFixMe ignore T type as it breaks storybooks.
export const TileContext = React.createContext({});

type TileContextProviderProps = {|
    children: React$Node,
    imageSize: ImageSizeType,
|};

export function TileContextProvider(props: TileContextProviderProps) {
    const { children, ...values } = props;

    return <TileContext.Provider value={values}>{children}</TileContext.Provider>;
}
